import React from 'react';
import { Steps, Button, Card, Typography, Row, Col, Divider } from 'antd';
import { UserAddOutlined, FormOutlined, CreditCardOutlined, DashboardOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../Header/PublicHeader';
import Footer from '../Footer';

const { Step } = Steps;
const { Title, Paragraph } = Typography;

const HowToJoin = () => {
  const navigate = useNavigate();

  const steps = [
    {
      title: "Choose a Membership Plan",
      description: "Select the membership tier that best suits your business needs and goals.",
      icon: <UserAddOutlined />,
    },
    {
      title: "Complete the Online Form",
      description: "Fill out your profile information and upload any required verification documents.",
      icon: <FormOutlined />,
    },
    {
      title: "Make Payment",
      description: "Process your payment through our secure gateway with multiple payment options.",
      icon: <CreditCardOutlined />,
    },
    {
      title: "Get APCCI Dashboard Access",
      description: "Gain immediate access to exclusive resources, networking events, and member benefits.",
      icon: <DashboardOutlined />,
    }
  ];

  return (
    <>
      <PublicHeader />
      
      {/* Hero Section */}
      <div className="bg-blue-50 py-16">
        <div className="container mx-auto text-center">
          <Card className="max-w-4xl mx-auto shadow-lg">
            <div className="py-8 px-6">
              <Title level={2} className="mb-4">Your Journey to Success Begins Here</Title>
              <Paragraph className="text-lg mb-8">
                Join APCCI and connect with industry leaders, access exclusive resources, and take your business to new heights.
              </Paragraph>
              
              {/* Steps Section */}
              <div className="mb-8">
                <Title level={3} className="mb-8">Four Simple Steps to Join Us</Title>
                
                <div className="mb-8 relative">
                  {/* Horizontal line connecting steps */}
                  <div className="hidden md:block absolute top-16 left-0 right-0 h-0.5 bg-gray-200 z-0" style={{ width: '80%', margin: '0 auto' }} />
                  
                  <Row gutter={[16, 36]} className="mb-8">
                    {steps.map((step, index) => (
                      <Col xs={24} sm={12} md={6} key={index}>
                        <div className="text-center relative z-10">
                          <div className="mb-4 flex justify-center">
                            <div className=" w-16 h-16 rounded-full flex items-center justify-center text-white border-4 border-white" style={{background:"linear-gradient(180deg, #0078BF 0%, #244183 100%)"}}>
                              {step.icon}
                            </div>
                          </div>
                          <div className="mb-2">
                            <div className="bg-gray-100 w-8 h-8 rounded-full flex items-center justify-center text-gray-700 font-semibold mx-auto">
                              {index + 1}
                            </div>
                          </div>
                          <Title level={4} className="mb-2">{step.title}</Title>
                          
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
              
              {/* Alternative horizontal steps with line */}
              <div className="mb-12 hidden">
                <Steps current={-1} className="custom-steps">
                  {steps.map((step, index) => (
                    <Step 
                      key={index} 
                      title={step.title} 
                      description={step.description} 
                      icon={step.icon} 
                    />
                  ))}
                </Steps>
              </div>
              
              {/* CTA Section */}
              <div className="text-center">
                <Button 
                  type="primary" 
                  size="large" 
                  onClick={() => navigate('/membership/plans')}
                  className="px-8 h-12"
                  style={{background:"linear-gradient(180deg, #0078BF 0%, #244183 100%)", borderRadius:"20px"}}
                >
                  Start Your Journey
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default HowToJoin;